<script setup>
import { ref } from 'vue'
import { MapLayer, MapSource, MapFeature } from '@/components/map'
import { LayerPlanetVars, LayerPlanetscope, LayerOrder, LayerRadar, LayerCollectedData } from '@/components/layers'

const emit = defineEmits(['isLoaded', 'deleteLayer'])
const props = defineProps({
  map: Object,
  item: Object,
  beforeId: String,
  layerId: String,
  orgId: Number,
  isVisible: Boolean,
})

const showGeometry = ref(false)
</script>

<template>
<div class="ml-2">
  <div>
    <MapSource
      :map="map"
      type="geojson"
      :id="layerId + '-source'"
      :data="{
        type: 'FeatureCollection',
        features: []
      }"
    >
      <MapLayer
        :map="map"
        :id="layerId"
        :source="layerId + '-source'"
        type="fill"
        :before-id="beforeId"
      >
        <div>
          <MapFeature
            v-if="showGeometry && item.geometry"
            :map="map"
            :feature="{ type: 'Feature', geometry: item.geometry, properties: {}}"
            :key="layerId"
            :options="{
              isFill: false
            }"
          />

          <LayerPlanetscope
            v-if="item.properties.type === 0"
            :map="map"
            :before-id="beforeId"
            :group-id="layerId"
            :org-id="orgId"
            :layer-id="layerId"
            :options="{
              layout: {
                visibility: isVisible ? 'visible' : 'none',
              },
            }"
            @isLoaded="emit('isLoaded', $event)"
          />

          <LayerOrder
            :map="map"
            :layer="item.properties.layer"
            :layer-id="layerId"
            v-if="item.properties.type === 1"
            :before-id="beforeId"
            :group-id="layerId"
            :options="{
              minzoom: 0,
              maxzoom: 22,
              layout: {
                visibility: isVisible ? 'visible' : 'none',
              },
            }"
            @isLoaded="emit('isLoaded', $event)"
          />

          <LayerPlanetVars
            v-if="item.properties.type === 2"
            :map="map"
            :layer-id="layerId"
            :code="item.properties.code"
            :layer="item.properties.layer"
            :before-id="beforeId"
            :group-id="layerId"
            :isVisible="isVisible"
            :options="{
              layout: {
                visibility: isVisible ? 'visible' : 'none',
              },
            }"
            @isLoaded="emit('isLoaded', $event)"
          />


          <LayerRadar
            v-if="item.properties.type === 3"
            :map="map"
            :layer-id="layerId"
            :code="item.uuid"
            :layer="item.properties.layer"
            :before-id="beforeId"
            :group-id="layerId"
            :is-visible="isVisible"
            :options="{
              layout: {
                visibility: isVisible ? 'visible' : 'none',
              },
            }"
            @isLoaded="emit('isLoaded', $event)"
          />

          <LayerCollectedData
            v-if="item.properties.type === 4"
            :map="map"
            :layer-id="layerId"
            :code="item.uuid"
            :layer="item.properties.layer"
            :org-id="orgId"
            :before-id="beforeId"
            :group-id="layerId"
            :options="{
              layout: {
                visibility: isVisible ? 'visible' : 'none',
              },
            }"
            @isLoaded="emit('isLoaded', $event)"
          />
        </div>


      </MapLayer>
    </MapSource>
  </div>
</div>
</template>
